import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, output } from '@angular/core';
import { ReactiveFormsModule, UntypedFormBuilder, UntypedFormControl } from '@angular/forms';
import { PaneComponent } from '@rocksoft/cdk';

@Component({
  selector: 'ml-personal-hotspot-ui',
  templateUrl: 'personal-hotspot.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [PaneComponent, ReactiveFormsModule, AsyncPipe],
})
export class ManagedSettingsPersonalHotspotComponent {
  private readonly fb = inject(UntypedFormBuilder);

  readonly personalHotspot = output<boolean>();

  public readonly personalHotspotForm = this.fb.group({
    personalHotspotEnabled: [false],
  });

  get personalHotspotEnabled() {
    return this.personalHotspotForm.get('personalHotspotEnabled') as UntypedFormControl;
  }

  onSubmit() {
    this.personalHotspot.emit(this.personalHotspotEnabled.value);
  }
}
